/* eslint-disable no-nested-ternary */
import React, { FC, useState, useEffect } from 'react';

import { useAutoApproval } from 'hooks/useAutoApproval';

import { Breadcumb, MainLayout, Header } from 'components';
import Loader from 'components/Loader';
import ErrorModal from 'components/ErrorModal';
import InitialScreen from './views/InitialScreen';
import InitialScreenWithData from './views/InitialScreenWithData';

const AutoApproval: FC = () => {
  const {
    data,
    isLoading,
    resetCurrentFormData,
    error,
    clearError,
  } = useAutoApproval();

  useEffect(() => {
    resetCurrentFormData();
  }, []);

  return (
    <MainLayout>
      <Breadcumb />
      <Header />

      {isLoading && <Loader />}

      {error && <ErrorModal handleOnClose={clearError} error={error} />}

      {!isLoading && (
        <>{data.length > 0 ? <InitialScreenWithData /> : <InitialScreen />}</>
      )}
    </MainLayout>
  );
};

export default AutoApproval;
